// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.status_video {
  position: absolute;
  top: 15px;
  left: 0px;
  padding: 4px 6px;
}
`, "",{"version":3,"sources":["webpack://./src/views/videosUser/AllVideo/styles/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;AACF","sourcesContent":[".status_video {\n  position: absolute;\n  top: 15px;\n  left: 0px;\n  padding: 4px 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
